import { render, staticRenderFns } from "./DashboardAdminSulut.vue?vue&type=template&id=6f85c0c5&lang=pug"
import script from "./DashboardAdminSulut.vue?vue&type=script&lang=js"
export * from "./DashboardAdminSulut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports